
export default {
  name: "Sheader",
  components: {},
  props: {
    title: {
      type: String,
      default: ""
    },
    showLogo: {
      type: Boolean,
      default: false
    },
    showBack: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      wellcomeLink: ""
    }
  },
  computed: {},
  watch: {},
  created() {
    this.wellcomeLink = this.MAIN_ORIGIN_HOME
  },
  mounted() {},
  methods: {
    handleBack() {
      window.history.back()
    }
  }
}
